"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_READ_TIMEOUT_LONG_MS = exports.API_READ_TIMEOUT_STANDARD_MS = void 0;
exports.API_READ_TIMEOUT_STANDARD_MS = 60 * 1000;
exports.API_READ_TIMEOUT_LONG_MS = 180 * 1000;
